import { db } from "./firebase"
import { isString } from "@/utils"

export default {
  escapeEmail(email) {
    if (!isString(email)) {
      return email
    }
    return email.replace(/\./g, "%2E")
  },

  unEscapeEmail(email) {
    if (!isString(email)) {
      return email
    }
    return email.replace(/%2E/g, ".")
  },

  userRef(email) {
    const escapedEmail = this.escapeEmail(email)
    return db.ref("users").child(escapedEmail)
  },

  userProjectsRef(email) {
    return this.userRef(email).child("projects")
  },

  async createUser(userCredentials) {
    const firebaseUser = userCredentials.user || {}
    const additionalUserInfo = userCredentials.additionalUserInfo || {}
    const user = {
      name: firebaseUser.displayName,
      email: firebaseUser.email,
      registered: new Date().getTime().toString(),
      providerId: additionalUserInfo.providerId
    }
    await this.userRef(firebaseUser.email).update(user)
    return user
  },

  onUserChanged(email, callback, errorCallback) {
    this.userRef(email).on(
      "value",
      snapshot => {
        const user = {
          projects: {},
          ...(snapshot.val() || {}),
          email
        }
        callback(user)
      },
      errorCallback
    )
  },

  offUserChanged(email) {
    this.userRef(email).off()
  },

  setProjectToUser(email, project) {
    return this.userProjectsRef(email)
      .child(project.id)
      .set(project.name)
  },

  removeProjectFromUser(email, projectId) {
    return this.userProjectsRef(email)
      .child(projectId)
      .set(null)
  },

  async setLangToUser(email, languague) {
    await this.userRef(email).update({ lang: languague })
    return languague
  }
}
